import { PcbTreeManager } from "../layout_engine/PcbTreeManager";
/**
 * Mutates the given document's PCB layout nodes to have the latest net and net property information
 *
 * Returns the tree manager that was used to perform the update, in case you want to e.g. check its state in a unit test
 */
export function updateDocumentNetNodes(document, logger) {
    const pcbTreeManager = new PcbTreeManager(document.pcbLayoutNodes ?? {}, logger);
    pcbTreeManager.updateNetNodes(document);
    document.pcbLayoutNodes = pcbTreeManager.treeNodes;
    return pcbTreeManager;
}
//# sourceMappingURL=updateNetNodes.js.map